function persistPageState(payload = {}) {
  localStorage.setItem(window.location.pathname, JSON.stringify(payload))
}

export default persistPageState
